/**
 * ewc-cart — gaveta de carrinho independente de tema.
 *
 * Painel próprio, montado a partir do /cart.js. Não depende de seção do tema, de
 * re-render por "sections", nem da marcação da gaveta nativa (que fica escondida).
 * O único contato com o tema é o ADAPTADOR: o que abre a gaveta (link/ícone do
 * carrinho e formulário de compra) e onde fica o contador de itens. Tudo com
 * detecção automática e escape manual pela config.
 *
 * Falha aberto: qualquer erro deixa o tema funcionando como antes.
 */
(function () {
  'use strict';
  if (window.EwcCart) return;

  var PADRAO = {
    textos: {
      titulo: 'Your Cart', vazio: 'Your cart is empty', anuncio: '', recompensa_antes: 'Only {{restante}} away from a {{brinde}}',
      recompensa_depois: 'You got a {{brinde}}!', economia: 'You Save', subtotal: 'Subtotal', checkout: 'CHECKOUT →',
      remover: 'Remove', upsell_titulo: 'Add More & Save More', upsell_adicionar: 'Add', garantia: '', so_upsell: 'Add a product to check out', gratis: 'FREE'
    },
    cores: { destaque: '#111111', fundo: '#ffffff', texto: '#111111', recompensa: '#ecb4cc' },
    largura: 440, raio: 10, timer_segundos: 0,
    // layout 'upcart': a estrutura da gaveta do UpCart (logo no topo, opções em linhas, lixeira,
    // preço com riscado + "(Save …)" + selo do desconto, sugestões em carrossel, linha de descontos
    // com selo). 'padrao' = a gaveta genérica. economia_so_descontos: a linha de economia do rodapé
    // soma só os descontos aplicados (como o UpCart), sem o compare-at.
    layout: 'padrao', logo: '', economia_so_descontos: false,
    brinde: null, upsells: [], selos: [],
    modulos: { anuncio: true, recompensas: true, upsells: true, selos: true, gate_so_upsell: true, economia: true },
    adaptador: { gatilhos: '', contadores: '', gaveta_nativa: '', ignorar_formularios: '', abrir_ao_adicionar: true }
  };

  var SEL = {
    gatilhos: 'a[href$="/cart"],a[href*="/cart?"],a[href$="/cart/"],[data-cart-drawer-toggle],[data-cart-toggle],cart-drawer-toggle,' +
              '#cart-icon-bubble,.header__icon--cart,.cart-icon,.js-drawer-open-cart,[aria-controls="cart-drawer"],[aria-controls="CartDrawer"],[data-action="open-cart"]',
    contadores: '.cart-count-bubble span[aria-hidden],.cart-count-bubble span:not(.visually-hidden),[data-cart-count],.cart-count,.cart-item-count,' +
                '.header__cart-count,.cart-link__bubble-num,.site-header__cart-count span,[data-header-cart-count]',
    gaveta_nativa: 'cart-drawer,#CartDrawer,.cart-drawer,#cart-drawer,#shopify-section-cart-drawer,.drawer--cart,[data-cart-drawer],.mini-cart,#mini-cart,' +
                   '.cart-popup,cart-notification,#cart-notification,.cart-notification,.upcart-cart'
  };

  var cfg, raiz, refs = {}, carrinho = null, aberto = false, ocupado = false, relogio = null, cacheProduto = {}, produtoPronto = {};

  /* ------------------------------------------------------------ util */
  function juntar(base, extra) {
    var s = {};
    Object.keys(base).forEach(function (k) { s[k] = base[k]; });
    Object.keys(extra || {}).forEach(function (k) {
      if (extra[k] && typeof extra[k] === 'object' && !Array.isArray(extra[k]) && base[k] && typeof base[k] === 'object')
        s[k] = juntar(base[k], extra[k]);
      else if (extra[k] !== undefined && extra[k] !== null) s[k] = extra[k];
    });
    return s;
  }
  function lerConfig() {
    var no = document.querySelector('[data-ewc-cart-config]');
    var bruto = {};
    try { bruto = JSON.parse(no ? no.textContent : '{}'); } catch (e) { bruto = {}; }
    var c = juntar(PADRAO, bruto.config || {});
    c.moneyFormat = bruto.moneyFormat || '${{amount}}';
    c.rotas = bruto.rotas || {};
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || c.rotas.raiz || '/';
    c.raiz = root.replace(/\/?$/, '/');
    return c;
  }
  function dinheiro(centavos) {
    var f = cfg.moneyFormat, v = (centavos / 100).toFixed(2), p = v.split('.');
    var inteiro = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return f.replace(/\{\{\s*amount\s*\}\}/g, inteiro + '.' + p[1])
            .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, inteiro)
            .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, inteiro.replace(/,/g, '.') + ',' + p[1])
            .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, inteiro.replace(/,/g, '.'))
            .replace(/<[^>]*>/g, '');
  }
  function el(tag, classe, texto) {
    var n = document.createElement(tag);
    if (classe) n.className = classe;
    if (texto != null) n.textContent = texto;
    return n;
  }
  function tpl(texto, vars) {
    return String(texto || '').replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, k) { return vars[k] != null ? vars[k] : ''; });
  }
  function ehBrinde(item) { return !!(item.properties && item.properties._ewc_gift) || (cfg.brinde && String(item.variant_id) === String(cfg.brinde.variante_id)); }
  function ehUpsell(item) { return !!(item.properties && (item.properties._ewc_upsell || item.properties.__upsell)); }
  function principais(c) { return c.items.filter(function (i) { return !ehBrinde(i) && !ehUpsell(i); }); }

  /* ------------------------------------------------------------ api */
  function pedir(rota, opts) {
    return fetch(cfg.raiz + rota, opts).then(function (r) {
      if (!r.ok) throw new Error(rota + ' ' + r.status);
      return r.json();
    });
  }
  var api = {
    carrinho: function () { return pedir('cart.js', { headers: { Accept: 'application/json' } }); },
    add: function (itens) {
      return pedir('cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: itens }) });
    },
    change: function (chave, qtd) {
      return pedir('cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: chave, quantity: qtd }) });
    },
    produto: function (handle) {
      if (cacheProduto[handle]) return cacheProduto[handle];
      cacheProduto[handle] = pedir('products/' + handle + '.js')
        .then(function (p) { if (p) produtoPronto[handle] = p; return p; })
        .catch(function () { delete cacheProduto[handle]; return null; });
      return cacheProduto[handle];
    }
  };

  /* ------------------------------------------------------------ montagem */
  function montar() {
    raiz.innerHTML = '';
    raiz.style.setProperty('--ewc-acento', cfg.cores.destaque);
    raiz.style.setProperty('--ewc-fundo', cfg.cores.fundo);
    raiz.style.setProperty('--ewc-texto', cfg.cores.texto);
    raiz.style.setProperty('--ewc-recompensa', cfg.cores.recompensa);
    raiz.style.setProperty('--ewc-largura', cfg.largura + 'px');
    raiz.style.setProperty('--ewc-raio', cfg.raio + 'px');
    if (cfg.fonte) raiz.style.setProperty('--ewc-fonte', cfg.fonte);
    if (cfg.cores.anuncio) raiz.style.setProperty('--ewc-anuncio', cfg.cores.anuncio);
    var upcart = cfg.layout === 'upcart';
    raiz.classList.toggle('ewc-cart--upcart', upcart);

    var fundo = el('div', 'ewc-cart__fundo'); fundo.addEventListener('click', fechar);
    var painel = el('aside', 'ewc-cart__painel'); painel.setAttribute('role', 'dialog'); painel.setAttribute('aria-modal', 'true');

    var topo = el('div', 'ewc-cart__topo');
    refs.titulo = el('h2', 'ewc-cart__titulo', cfg.textos.titulo);
    var fecharBtn = el('button', 'ewc-cart__fechar'); fecharBtn.type = 'button'; fecharBtn.setAttribute('aria-label', 'Close');
    fecharBtn.innerHTML = '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 4l12 12M16 4L4 16"/></svg>';
    fecharBtn.addEventListener('click', fechar);
    if (upcart && cfg.logo) {
      var logo = el('img', 'ewc-cart__logo'); logo.src = cfg.logo; logo.alt = ''; topo.appendChild(logo);
      refs.titulo.hidden = true;
    }
    topo.appendChild(refs.titulo); topo.appendChild(fecharBtn);

    refs.anuncio = el('div', 'ewc-cart__anuncio'); refs.anuncio.hidden = true;
    // '{TIMER}' no meio do texto (como o UpCart escreve) põe o relógio naquele ponto; sem ele, o relógio vai no fim
    var partesAnuncio = String(cfg.textos.anuncio || '').split('{TIMER}');
    refs.anuncioTexto = el('span', null, partesAnuncio[0]); refs.timer = el('span', 'ewc-cart__timer');
    refs.anuncio.appendChild(refs.anuncioTexto); refs.anuncio.appendChild(refs.timer);
    if (partesAnuncio.length > 1) refs.anuncio.appendChild(el('span', null, partesAnuncio.slice(1).join('')));

    refs.recompensas = el('div', 'ewc-cart__recompensas'); refs.recompensas.hidden = true;
    refs.recompensaMsg = el('p', 'ewc-cart__recompensas-msg');
    var trilho = el('div', 'ewc-cart__trilho'); refs.preench = el('div', 'ewc-cart__preenchimento');
    var marco = el('div', 'ewc-cart__marco'); refs.marcoIcone = el('div', 'ewc-cart__marco-icone');
    refs.marcoIcone.innerHTML = '<svg viewBox="0 0 20 20" fill="currentColor"><path d="M3 8h14v9H3zM2 5h16v3H2zM10 5v12M7 5c-1.5 0-2.5-1-2.5-2S5.5 1 7 1s3 2 3 4M13 5c1.5 0 2.5-1 2.5-2S14.5 1 13 1s-3 2-3 4"/></svg>';
    refs.marcoRotulo = el('div', 'ewc-cart__marco-rotulo', cfg.brinde ? cfg.brinde.rotulo : '');
    marco.appendChild(refs.marcoIcone); marco.appendChild(refs.marcoRotulo);
    trilho.appendChild(refs.preench); trilho.appendChild(marco);
    refs.recompensas.appendChild(refs.recompensaMsg); refs.recompensas.appendChild(trilho);

    refs.corpo = el('div', 'ewc-cart__corpo');
    refs.itens = el('div', 'ewc-cart__itens');
    refs.upsells = el('div', 'ewc-cart__upsells'); refs.upsells.hidden = true;
    refs.corpo.appendChild(refs.itens); refs.corpo.appendChild(refs.upsells);

    var rodape = el('div', 'ewc-cart__rodape');
    refs.economia = el('div', 'ewc-cart__economia'); refs.economia.hidden = true;
    var econRot = el('span', 'ewc-cart__economia-rotulo'); econRot.appendChild(el('span', null, cfg.textos.economia));
    refs.economiaSelos = el('span', 'ewc-cart__economia-selos'); econRot.appendChild(refs.economiaSelos);
    refs.economia.appendChild(econRot); refs.economiaValor = el('span', 'ewc-cart__economia-valor'); refs.economia.appendChild(refs.economiaValor);
    var subtotal = el('div', 'ewc-cart__subtotal'); subtotal.appendChild(el('span', null, cfg.textos.subtotal)); refs.subtotal = el('span'); subtotal.appendChild(refs.subtotal);
    refs.aviso = el('div', 'ewc-cart__aviso', cfg.textos.so_upsell); refs.aviso.hidden = true;
    refs.checkout = el('a', 'ewc-cart__checkout', cfg.textos.checkout); refs.checkout.href = cfg.raiz + 'checkout';
    refs.checkout.addEventListener('click', function (ev) { if (refs.checkout.classList.contains('is-disabled')) ev.preventDefault(); });
    rodape.appendChild(refs.economia); rodape.appendChild(subtotal); rodape.appendChild(refs.aviso); rodape.appendChild(refs.checkout);
    if (cfg.textos.garantia) rodape.appendChild(el('p', 'ewc-cart__garantia', cfg.textos.garantia));
    if (cfg.modulos.selos && cfg.selos && cfg.selos.length) {
      var selos = el('div', 'ewc-cart__selos');
      cfg.selos.forEach(function (nome) {
        // selo como imagem ({src, alt}: a faixa de bandeiras que o UpCart mostra como imagem)
        if (nome && typeof nome === 'object' && nome.src) { var im = el('img', 'ewc-cart__selo-img'); im.src = nome.src; im.alt = nome.alt || ''; im.loading = 'lazy'; selos.appendChild(im); return; }
        var svg = document.querySelector('template[data-ewc-selo="' + nome + '"]');
        if (svg) selos.appendChild(svg.content.cloneNode(true));
        else { var chip = el('span', 'ewc-cart__chip', String(nome).replace(/_/g, ' ').toUpperCase()); chip.style.background = '#eee'; chip.style.color = '#333'; selos.appendChild(chip); }
      });
      rodape.appendChild(selos);
    }

    painel.appendChild(topo); painel.appendChild(refs.anuncio); painel.appendChild(refs.recompensas);
    painel.appendChild(refs.corpo); painel.appendChild(rodape);
    raiz.appendChild(fundo); raiz.appendChild(painel);

    raiz.addEventListener('click', function (ev) {
      var b = ev.target.closest && ev.target.closest('[data-ewc-acao]');
      if (!b) return;
      var acao = b.getAttribute('data-ewc-acao'), chave = b.getAttribute('data-ewc-chave'), qtd = parseInt(b.getAttribute('data-ewc-qtd') || '0', 10);
      if (acao === 'mais') mudar(chave, qtd + 1);
      else if (acao === 'menos') mudar(chave, Math.max(0, qtd - 1));
      else if (acao === 'remover') mudar(chave, 0);
      else if (acao === 'upsell') adicionarUpsell(b);
    });
    document.addEventListener('keydown', function (ev) { if (ev.key === 'Escape' && aberto) fechar(); });
  }

  /* ------------------------------------------------------------ render */
  function render(c) {
    carrinho = c;
    var vazio = !c.items.length;
    refs.itens.innerHTML = '';
    if (vazio) refs.itens.appendChild(el('div', 'ewc-cart__vazio', cfg.textos.vazio));
    c.items.forEach(function (item) { refs.itens.appendChild(linha(item)); });

    refs.titulo.textContent = cfg.textos.titulo + (c.item_count ? ' • ' + c.item_count : '');
    refs.anuncio.hidden = !(cfg.modulos.anuncio && cfg.textos.anuncio && !vazio);
    if (!refs.anuncio.hidden) ligarTimer();

    if (cfg.modulos.recompensas && cfg.brinde && cfg.brinde.limiar) {
      refs.recompensas.hidden = vazio;
      var limiar = Math.round(cfg.brinde.limiar * 100);
      var total = principais(c).reduce(function (s, i) { return s + i.final_line_price; }, 0);
      var pct = Math.min(100, total / limiar * 100);
      refs.preench.style.width = pct.toFixed(2) + '%';
      var chegou = total >= limiar;
      refs.marcoIcone.classList.toggle('is-complete', chegou);
      refs.recompensaMsg.innerHTML = chegou ? tpl(cfg.textos.recompensa_depois, { brinde: '<strong>' + cfg.brinde.rotulo + '</strong>' })
        : tpl(cfg.textos.recompensa_antes, { restante: '<strong>' + dinheiro(limiar - total) + '</strong>', brinde: '<strong>' + cfg.brinde.rotulo + '</strong>' });
    } else refs.recompensas.hidden = true;

    raiz.classList.toggle('is-vazio', vazio);
    // o compare-at vem do /products/x.js: quando chega, a linha (upcart) ou a economia se refaz
    c.items.forEach(function (i) { if (i.handle && !cacheProduto[i.handle]) api.produto(i.handle).then(function () { if (carrinho !== c) return; if (cfg.layout === 'upcart') render(c); else atualizarEconomia(c); }); });
    atualizarEconomia(c);
    refs.subtotal.textContent = dinheiro(c.total_price);
    // 'Checkout • {{total_price}}' (texto do UpCart): o total entra no botão
    if (/\{\{\s*total_price\s*\}\}/.test(cfg.textos.checkout)) refs.checkout.textContent = cfg.textos.checkout.replace(/\{\{\s*total_price\s*\}\}/g, dinheiro(c.total_price));

    var soAcessorio = c.item_count > 0 && principais(c).length === 0 && cfg.modulos.gate_so_upsell;
    refs.checkout.classList.toggle('is-disabled', vazio || soAcessorio);
    refs.aviso.hidden = !soAcessorio;

    renderUpsells(c);
    atualizarContadores(c.item_count);
    brindeAutomatico(c);
    document.dispatchEvent(new CustomEvent('ewc:cart:updated', { detail: { cart: c } }));
  }
  function atualizarEconomia(c) {
    var descontos = c.items.reduce(function (s, i) { return s + (i.original_line_price - i.final_line_price); }, 0);
    var economia = cfg.economia_so_descontos ? descontos : descontos + compareAt(c);
    refs.economia.hidden = !(cfg.modulos.economia && economia > 0);
    refs.economiaValor.textContent = (cfg.layout === 'upcart' ? '- ' : '-') + dinheiro(economia);
    refs.economiaSelos.innerHTML = '';
    if (cfg.layout === 'upcart') titulosDesconto(c.items).forEach(function (t) { refs.economiaSelos.appendChild(seloDesconto(t)); });
  }
  function titulosDesconto(itens) {
    var vistos = [];
    itens.forEach(function (i) { (i.line_level_discount_allocations || []).forEach(function (al) { var t = al.discount_application && al.discount_application.title; if (t && vistos.indexOf(t) < 0) vistos.push(t); }); });
    return vistos;
  }
  var ICONE_ETIQUETA = '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M3 10.6V4a1 1 0 0 1 1-1h6.6a1 1 0 0 1 .7.3l6 6a1 1 0 0 1 0 1.4l-6.6 6.6a1 1 0 0 1-1.4 0l-6-6a1 1 0 0 1-.3-.7Z"/><circle cx="7" cy="7" r="1.3" fill="currentColor" stroke="none"/></svg>';
  function seloDesconto(t) {
    var s = el('span', 'ewc-cart__selo-desconto');
    var ic = el('span', 'ewc-cart__selo-desconto-icone'); ic.innerHTML = ICONE_ETIQUETA;
    s.appendChild(ic); s.appendChild(el('span', 'ewc-cart__selo-desconto-texto', t));
    return s;
  }
  function compareAt(c) {
    // economia contra o preço de tabela, quando o produto tem compare-at (lido do /products/x.js já em cache)
    var soma = 0;
    c.items.forEach(function (i) {
      var p = produtoPronto[i.handle];
      if (!p) return;
      var v = (p.variants || []).filter(function (x) { return x.id === i.variant_id; })[0];
      if (v && v.compare_at_price > i.original_price) soma += (v.compare_at_price - i.original_price) * i.quantity;
    });
    return soma;
  }
  function precoCheio(item) {
    // riscado da linha no UpCart: compare-at × quantidade (sem compare-at, o preço antes do desconto)
    var p = produtoPronto[item.handle];
    var v = p && (p.variants || []).filter(function (x) { return x.id === item.variant_id; })[0];
    var base = v && v.compare_at_price > item.original_price ? v.compare_at_price * item.quantity : item.original_line_price;
    return Math.max(base, item.original_line_price);
  }
  var LIXEIRA = '<svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><path d="M8 3.994c0-1.101.895-1.994 2-1.994s2 .893 2 1.994h4c.552 0 1 .446 1 .997a1 1 0 0 1-1 .997h-12c-.552 0-1-.447-1-.997s.448-.997 1-.997h4zm-3 10.514v-6.508h2v6.508a.5.5 0 0 0 .5.498h1.5v-7.006h2v7.006h1.5a.5.5 0 0 0 .5-.498v-6.508h2v6.508a2.496 2.496 0 0 1-2.5 2.492h-5c-1.38 0-2.5-1.115-2.5-2.492z"/></svg>';
  function linhaUpcart(item) {
    var brinde = ehBrinde(item) || item.final_line_price === 0;
    var n = el('div', 'ewc-cart__item');
    var img = el('img', 'ewc-cart__img'); if (item.image) img.src = item.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_180x180$1$2'); img.alt = '';
    var info = el('div', 'ewc-cart__info');
    var cabeca = el('div', 'ewc-cart__cabeca');
    var textos = el('div', 'ewc-cart__textos');
    var nome = el('h3', 'ewc-cart__nome'); var a = el('a', null, item.product_title); a.href = item.url; nome.appendChild(a); textos.appendChild(nome);
    (item.options_with_values || []).forEach(function (o) {
      if (!o || o.value === 'Default Title') return;
      var op = el('div', 'ewc-cart__opcao'); op.appendChild(el('span', 'ewc-cart__opcao-nome', o.name + ':')); op.appendChild(el('span', 'ewc-cart__opcao-valor', o.value)); textos.appendChild(op);
    });
    Object.keys(item.properties || {}).forEach(function (k) { if (k.charAt(0) !== '_' && item.properties[k]) { var op = el('div', 'ewc-cart__opcao'); op.appendChild(el('span', 'ewc-cart__opcao-nome', k + ':')); op.appendChild(el('span', 'ewc-cart__opcao-valor', item.properties[k])); textos.appendChild(op); } });
    cabeca.appendChild(textos);
    var lix = el('button', 'ewc-cart__lixeira'); lix.type = 'button'; lix.setAttribute('aria-label', cfg.textos.remover); lix.innerHTML = LIXEIRA;
    lix.setAttribute('data-ewc-acao', 'remover'); lix.setAttribute('data-ewc-chave', item.key);
    cabeca.appendChild(lix);
    info.appendChild(cabeca);
    var baixo = el('div', 'ewc-cart__linha-baixo');
    if (brinde) baixo.appendChild(el('span', 'ewc-cart__chip ewc-cart__chip--gratis', cfg.textos.gratis));
    else {
      var q = el('div', 'ewc-cart__qtd');
      var menos = el('button'); menos.type = 'button'; menos.setAttribute('aria-label', '-'); menos.innerHTML = '<svg viewBox="0 0 12 12" aria-hidden="true"><path d="M1 6h10" stroke="currentColor" stroke-width="1.5"/></svg>';
      menos.setAttribute('data-ewc-acao', 'menos'); menos.setAttribute('data-ewc-chave', item.key); menos.setAttribute('data-ewc-qtd', item.quantity);
      var campo = el('input', 'ewc-cart__qtd-campo'); campo.type = 'text'; campo.readOnly = true; campo.value = String(item.quantity); campo.setAttribute('aria-label', 'Quantity');
      var mais = el('button'); mais.type = 'button'; mais.setAttribute('aria-label', '+'); mais.innerHTML = '<svg viewBox="0 0 12 12" aria-hidden="true"><path d="M1 6h10M6 1v10" stroke="currentColor" stroke-width="1.5"/></svg>';
      mais.setAttribute('data-ewc-acao', 'mais'); mais.setAttribute('data-ewc-chave', item.key); mais.setAttribute('data-ewc-qtd', item.quantity);
      q.appendChild(menos); q.appendChild(campo); q.appendChild(mais); baixo.appendChild(q);
    }
    info.appendChild(baixo);
    var preco = el('div', 'ewc-cart__preco-col'); baixo.appendChild(preco);
    var linhaP = el('div', 'ewc-cart__precos');
    var cheio = brinde ? item.original_line_price : precoCheio(item);
    if (cheio > item.final_line_price) linhaP.appendChild(el('span', 'ewc-cart__riscado', dinheiro(cheio)));
    linhaP.appendChild(el('span', 'ewc-cart__preco-final', dinheiro(item.final_line_price)));
    preco.appendChild(linhaP);
    if (cheio > item.final_line_price && !brinde) preco.appendChild(el('span', 'ewc-cart__economia-linha', tpl(cfg.textos.economia_linha || '(Save {{valor}})', { valor: dinheiro(cheio - item.final_line_price) })));
    titulosDesconto([item]).forEach(function (t) { preco.appendChild(seloDesconto(t)); });
    n.appendChild(img); n.appendChild(info);
    return n;
  }
  function linha(item) {
    if (cfg.layout === 'upcart') return linhaUpcart(item);
    var brinde = ehBrinde(item) || item.final_line_price === 0;
    var n = el('div', 'ewc-cart__item');
    var img = el('img', 'ewc-cart__img'); if (item.image) img.src = item.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_180x180$1$2'); img.alt = '';
    var info = el('div', 'ewc-cart__info');
    var nome = el('h3', 'ewc-cart__nome'); var a = el('a', null, item.product_title); a.href = item.url; nome.appendChild(a);
    info.appendChild(nome);
    if (item.variant_title && item.variant_title !== 'Default Title') info.appendChild(el('p', 'ewc-cart__variante', item.variant_title));
    Object.keys(item.properties || {}).forEach(function (k) { if (k.charAt(0) !== '_' && item.properties[k]) info.appendChild(el('p', 'ewc-cart__variante', k + ': ' + item.properties[k])); });
    var chips = el('div');
    if (brinde) chips.appendChild(el('span', 'ewc-cart__chip ewc-cart__chip--gratis', cfg.textos.gratis));
    (item.line_level_discount_allocations || []).forEach(function (al) {
      var t = al.discount_application && al.discount_application.title;
      if (t) chips.appendChild(el('span', 'ewc-cart__chip', t));
    });
    if (chips.childNodes.length) info.appendChild(chips);
    var baixo = el('div', 'ewc-cart__linha-baixo');
    if (brinde) { baixo.appendChild(el('span', 'ewc-cart__variante', cfg.textos.gratis)); }
    else {
      var q = el('div', 'ewc-cart__qtd');
      var menos = el('button', null, '−'); menos.type = 'button'; menos.setAttribute('data-ewc-acao', 'menos'); menos.setAttribute('data-ewc-chave', item.key); menos.setAttribute('data-ewc-qtd', item.quantity);
      var mais = el('button', null, '+'); mais.type = 'button'; mais.setAttribute('data-ewc-acao', 'mais'); mais.setAttribute('data-ewc-chave', item.key); mais.setAttribute('data-ewc-qtd', item.quantity);
      q.appendChild(menos); q.appendChild(el('span', null, String(item.quantity))); q.appendChild(mais); baixo.appendChild(q);
    }
    var preco = el('div', 'ewc-cart__preco');
    if (item.original_line_price > item.final_line_price) preco.appendChild(el('span', 'ewc-cart__riscado', dinheiro(item.original_line_price)));
    preco.appendChild(document.createTextNode(brinde && item.final_line_price === 0 ? dinheiro(0) : dinheiro(item.final_line_price)));
    baixo.appendChild(preco);
    info.appendChild(baixo);
    var rem = el('button', 'ewc-cart__remover', cfg.textos.remover); rem.type = 'button'; rem.setAttribute('data-ewc-acao', 'remover'); rem.setAttribute('data-ewc-chave', item.key);
    info.appendChild(rem);
    n.appendChild(img); n.appendChild(info);
    return n;
  }
  function renderUpsells(c) {
    if (!cfg.modulos.upsells || !cfg.upsells || !cfg.upsells.length || !c.items.length) { refs.upsells.hidden = true; return; }
    var noCarrinho = {}; c.items.forEach(function (i) { noCarrinho[i.handle] = true; });
    var candidatos = cfg.upsells.filter(function (u) {
      if (noCarrinho[u.handle]) return false;
      if (u.gatilho_handles && u.gatilho_handles.length) return u.gatilho_handles.some(function (h) { return noCarrinho[h]; });
      return true;
    });
    if (!candidatos.length) { refs.upsells.hidden = true; return; }
    refs.upsells.hidden = false; refs.upsells.innerHTML = '';
    if (cfg.textos.upsell_titulo) refs.upsells.appendChild(el('p', 'ewc-cart__upsells-titulo', cfg.textos.upsell_titulo));
    var alvo = refs.upsells, upcart = cfg.layout === 'upcart';
    if (upcart) {
      // carrossel de um cartão por vez, com setas nas pontas (como o do UpCart)
      var car = el('div', 'ewc-cart__carrossel'), janela = el('div', 'ewc-cart__carrossel-janela'), trilho = el('div', 'ewc-cart__carrossel-trilho');
      var ant = el('button', 'ewc-cart__seta ewc-cart__seta--ant'), prox = el('button', 'ewc-cart__seta ewc-cart__seta--prox');
      ant.type = prox.type = 'button'; ant.setAttribute('aria-label', 'Previous'); prox.setAttribute('aria-label', 'Next');
      ant.innerHTML = '<svg viewBox="0 0 10 16" aria-hidden="true"><path d="M8 1 2 8l6 7" fill="none" stroke="currentColor" stroke-width="2"/></svg>';
      prox.innerHTML = '<svg viewBox="0 0 10 16" aria-hidden="true"><path d="m2 1 6 7-6 7" fill="none" stroke="currentColor" stroke-width="2"/></svg>';
      var idx = 0;
      var ir = function (i) { var n = trilho.children.length || 1; idx = (i + n) % n; trilho.style.transform = 'translateX(' + (-100 * idx) + '%)'; car.classList.toggle('is-unico', n < 2); };
      ant.addEventListener('click', function () { ir(idx - 1); }); prox.addEventListener('click', function () { ir(idx + 1); });
      // deslizar (dedo ou mouse) troca o cartão; arrasto curto volta ao lugar; o clique que
      // encerra um arrasto não abre o produto
      var x0 = null, y0 = 0, arrastou = false, larg = 1;
      janela.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        if (e.target.closest('select, button')) return;
        x0 = e.clientX; y0 = e.clientY; larg = janela.offsetWidth || 1; arrastou = false;
      });
      janela.addEventListener('pointermove', function (e) {
        if (x0 === null) return;
        var dx = e.clientX - x0;
        if (!arrastou && Math.abs(dx) > 8 && Math.abs(dx) > Math.abs(e.clientY - y0)) {
          arrastou = true; trilho.style.transition = 'none';
          try { janela.setPointerCapture(e.pointerId); } catch (_) {}
        }
        if (arrastou) trilho.style.transform = 'translateX(calc(' + (-100 * idx) + '% + ' + dx + 'px))';
      });
      var soltar = function (e) {
        if (x0 === null) return;
        var dx = e.clientX - x0; x0 = null; trilho.style.transition = '';
        if (arrastou) ir(Math.abs(dx) > larg * 0.15 ? idx + (dx < 0 ? 1 : -1) : idx);
      };
      janela.addEventListener('pointerup', soltar);
      janela.addEventListener('pointercancel', function () { if (x0 === null) return; x0 = null; trilho.style.transition = ''; ir(idx); });
      janela.addEventListener('click', function (e) { if (arrastou) { e.preventDefault(); e.stopPropagation(); arrastou = false; } }, true);
      janela.addEventListener('dragstart', function (e) { e.preventDefault(); });
      janela.appendChild(trilho); car.appendChild(ant); car.appendChild(janela); car.appendChild(prox);
      refs.upsells.appendChild(car); alvo = trilho;
      car.nestiIr = ir;
    }
    candidatos.forEach(function (u) {
      var tile = el('div', 'ewc-cart__upsell'); tile.setAttribute('data-ewc-upsell', u.handle);
      alvo.appendChild(tile);
      if (upcart) car.nestiIr(0);
      api.produto(u.handle).then(function (p) {
        if (!p) { tile.remove(); return; }
        var fotoDe = function (v) { var f = (v && v.featured_image && v.featured_image.src) || p.featured_image || ''; return String(f).replace(/(\.[a-z]+)(\?.*)?$/i, '_180x180$1$2'); };
        var img = el('img'); img.alt = '';
        var info = el('div', 'ewc-cart__upsell-info'); info.appendChild(el('strong', null, p.title));
        var v0 = p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
        img.src = upcart ? fotoDe(v0) : String(p.featured_image || '').replace(/(\.[a-z]+)(\?.*)?$/i, '_120x120$1$2');
        var precoTxt = el('span'); precoTxt.innerHTML = (v0.compare_at_price > v0.price ? '<span class="ewc-cart__riscado">' + dinheiro(v0.compare_at_price) + '</span>' : '') + dinheiro(v0.price);
        info.appendChild(precoTxt);
        var sel = null;
        if (p.variants.length > 1) {
          sel = el('select');
          p.variants.forEach(function (v) { var o = el('option', null, v.title); o.value = v.id; o.disabled = !v.available; sel.appendChild(o); });
          sel.value = String(v0.id);
          sel.addEventListener('change', function () { var v = p.variants.filter(function (x) { return String(x.id) === sel.value; })[0]; if (v) precoTxt.innerHTML = (v.compare_at_price > v.price ? '<span class="ewc-cart__riscado">' + dinheiro(v.compare_at_price) + '</span>' : '') + dinheiro(v.price); });
          info.appendChild(sel);
        }
        var btn = el('button', 'ewc-cart__upsell-add', cfg.textos.upsell_adicionar); btn.type = 'button';
        btn.setAttribute('data-ewc-acao', 'upsell'); btn.setAttribute('data-ewc-variante', String(v0.id));
        if (sel) sel.addEventListener('change', function () { btn.setAttribute('data-ewc-variante', sel.value); if (upcart) { var vv = p.variants.filter(function (x) { return String(x.id) === sel.value; })[0]; img.src = fotoDe(vv); } });
        if (upcart) {
          // variante e botão na mesma linha, embaixo do preço
          var acoes = el('div', 'ewc-cart__upsell-acoes');
          if (sel) { var sw = el('div', 'ewc-cart__upsell-select'); sw.appendChild(sel); acoes.appendChild(sw); }
          acoes.appendChild(btn); info.appendChild(acoes);
          var link = el('a', 'ewc-cart__upsell-img'); link.href = (cfg.raiz + 'products/' + u.handle).replace(/\/\/products/, '/products'); link.appendChild(img);
          tile.appendChild(link); tile.appendChild(info);
          if (car) car.nestiIr(0);
        } else { tile.appendChild(img); tile.appendChild(info); tile.appendChild(btn); }
      });
    });
  }

  /* ------------------------------------------------------------ ações */
  function atualizar() { return api.carrinho().then(render).catch(function () {}); }
  function mudar(chave, qtd) {
    if (ocupado) return; ocupado = true;
    api.change(chave, qtd).then(render).catch(function () {}).then(function () { ocupado = false; });
  }
  function adicionarUpsell(btn) {
    var vid = parseInt(btn.getAttribute('data-ewc-variante') || '0', 10); if (!vid || ocupado) return;
    ocupado = true; btn.disabled = true;
    api.add([{ id: vid, quantity: 1, properties: { _ewc_upsell: '1' } }]).then(atualizar).catch(function () {}).then(function () { ocupado = false; btn.disabled = false; });
  }
  var brindeOcupado = false;
  function brindeAutomatico(c) {
    var b = cfg.brinde; if (!b || !b.variante_id || !b.limiar || brindeOcupado) return;
    var limiar = Math.round(b.limiar * 100);
    var linhasBrinde = c.items.filter(ehBrinde);
    var total = principais(c).reduce(function (s, i) { return s + i.final_line_price; }, 0);
    var elegivel = total >= limiar && principais(c).length > 0;
    var ss = window.sessionStorage;
    function guardar(k, v) { try { v == null ? ss.removeItem(k) : ss.setItem(k, v); } catch (e) {} }
    function ler(k) { try { return ss.getItem(k); } catch (e) { return null; } }
    if (elegivel && !linhasBrinde.length && !ler('ewcBrindeRemovido')) {
      brindeOcupado = true;
      api.add([{ id: parseInt(b.variante_id, 10), quantity: 1, properties: { _ewc_gift: '1' } }])
        .then(function () { guardar('ewcBrindeAdicionado', '1'); return atualizar(); }).catch(function () {}).then(function () { brindeOcupado = false; });
    } else if (!elegivel && linhasBrinde.length) {
      brindeOcupado = true;
      api.change(linhasBrinde[0].key, 0).then(function (nc) { guardar('ewcBrindeAdicionado', null); render(nc); }).catch(function () {}).then(function () { brindeOcupado = false; });
    } else if (elegivel && !linhasBrinde.length && ler('ewcBrindeAdicionado')) {
      guardar('ewcBrindeRemovido', '1'); guardar('ewcBrindeAdicionado', null);   // o cliente tirou de propósito
    } else if (linhasBrinde.length && linhasBrinde[0].quantity > 1) {
      brindeOcupado = true;
      api.change(linhasBrinde[0].key, 1).then(render).catch(function () {}).then(function () { brindeOcupado = false; });
    }
  }
  function ligarTimer() {
    if (!cfg.timer_segundos) { refs.timer.textContent = ''; return; }
    var chave = 'ewcTimerInicio', inicio;
    try { inicio = parseInt(sessionStorage.getItem(chave) || '0', 10); } catch (e) { inicio = 0; }
    if (!inicio) { inicio = Date.now(); try { sessionStorage.setItem(chave, String(inicio)); } catch (e) {} }
    function tique() {
      var resta = Math.max(0, cfg.timer_segundos - Math.floor((Date.now() - inicio) / 1000));
      var m = Math.floor(resta / 60), s = resta % 60;
      refs.timer.textContent = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
      if (resta === 0) { clearInterval(relogio); relogio = null; }
    }
    tique(); if (!relogio) relogio = setInterval(tique, 1000);
  }
  function atualizarContadores(n) {
    var sel = SEL.contadores + (cfg.adaptador.contadores ? ',' + cfg.adaptador.contadores : '');
    document.querySelectorAll(sel).forEach(function (e) {
      if (raiz.contains(e)) return;
      if (/^\s*\d*\s*$/.test(e.textContent)) e.textContent = String(n);
      else e.textContent = e.textContent.replace(/\d+/, String(n));
    });
  }

  /* ------------------------------------------------------------ abrir / fechar */
  function abrir() {
    if (aberto) return;
    aberto = true; raiz.hidden = false; raiz.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(function () { raiz.classList.add('is-open'); });
    document.documentElement.classList.add('ewc-cart-aberto');
    atualizar();
    document.dispatchEvent(new CustomEvent('ewc:cart:open'));
  }
  function fechar() {
    if (!aberto) return;
    aberto = false; raiz.classList.remove('is-open'); document.documentElement.classList.remove('ewc-cart-aberto');
    setTimeout(function () { if (!aberto) { raiz.hidden = true; raiz.setAttribute('aria-hidden', 'true'); } }, 300);
  }

  /* ------------------------------------------------------------ adaptador */
  function esconderNativa() {
    var css = document.createElement('style');
    css.setAttribute('data-ewc-cart', 'esconde-nativa');
    var sel = SEL.gaveta_nativa + (cfg.adaptador.gaveta_nativa ? ',' + cfg.adaptador.gaveta_nativa : '');
    css.textContent = sel + '{display:none !important;visibility:hidden !important}';
    document.head.appendChild(css);
  }
  function instalarGatilhos() {
    var sel = SEL.gatilhos + (cfg.adaptador.gatilhos ? ',' + cfg.adaptador.gatilhos : '');
    document.addEventListener('click', function (ev) {
      var alvo = ev.target.closest && ev.target.closest(sel);
      if (!alvo || raiz.contains(alvo) || alvo.hasAttribute('data-ewc-skip')) return;
      var href = alvo.getAttribute('href') || '';
      if (href && !/\/cart(\/|\?|$)/.test(href)) return;
      ev.preventDefault(); ev.stopPropagation(); ev.stopImmediatePropagation();
      abrir();
    }, true);
  }
  function itensDoFormulario(form) {
    var fd = new FormData(form), id = parseInt(fd.get('id') || '0', 10), qtd = parseInt(fd.get('quantity') || '1', 10) || 1, props = {};
    fd.forEach(function (v, k) { var m = /^properties\[(.+)\]$/.exec(k); if (m && v !== '') props[m[1]] = v; });
    if (!id) return null;
    var item = { id: id, quantity: qtd }; if (Object.keys(props).length) item.properties = props;
    var plano = fd.get('selling_plan'); if (plano) item.selling_plan = plano;
    return [item];
  }
  function instalarFormularios() {
    var ignorar = cfg.adaptador.ignorar_formularios;
    document.addEventListener('submit', function (ev) {
      var form = ev.target;
      if (!form || !/\/cart\/add/.test(form.getAttribute('action') || '')) return;
      if (raiz.contains(form) || form.hasAttribute('data-ewc-skip') || form.hasAttribute('data-ewc-bundle-form')) return;
      if (ignorar && form.closest(ignorar)) return;
      var itens = itensDoFormulario(form); if (!itens) return;
      ev.preventDefault(); ev.stopPropagation(); ev.stopImmediatePropagation();
      var btn = form.querySelector('[type="submit"],button[name="add"]'); if (btn) btn.disabled = true;
      api.add(itens).then(function () { if (cfg.adaptador.abrir_ao_adicionar !== false) abrir(); else atualizar(); })
        .catch(function () { form.submit(); })
        .then(function () { if (btn) btn.disabled = false; });
    }, true);
  }
  function vigiarRede() {
    // o tema pode adicionar por JavaScript próprio (sem submit): ver a rede é o único gancho que vale em todo tema
    var fetchOriginal = window.fetch;
    if (typeof fetchOriginal === 'function' && !fetchOriginal._ewc) {
      var f = function (entrada, opts) {
        var url = typeof entrada === 'string' ? entrada : (entrada && entrada.url) || '';
        var p = fetchOriginal.apply(this, arguments);
        if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url) && !(opts && opts.headers && opts.headers['X-Ewc'])) {
          p.then(function (r) {
            if (!r.ok) return;
            if (/\/cart\/add/.test(url) && cfg.adaptador.abrir_ao_adicionar !== false) abrir(); else if (aberto) atualizar();
          }).catch(function () {});
        }
        return p;
      };
      f._ewc = true; window.fetch = f;
    }
    var abrirXhr = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (m, url) {
      if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(String(url))) {
        this.addEventListener('load', function () {
          if (this.status >= 200 && this.status < 300) { if (/\/cart\/add/.test(String(url)) && cfg.adaptador.abrir_ao_adicionar !== false) abrir(); else if (aberto) atualizar(); }
        });
      }
      return abrirXhr.apply(this, arguments);
    };
  }

  /* ------------------------------------------------------------ início */
  function iniciar() {
    raiz = document.getElementById('ewc-cart-root'); if (!raiz) return;
    cfg = lerConfig();
    montar(); esconderNativa(); instalarGatilhos(); instalarFormularios(); vigiarRede();
    document.addEventListener('ewc:cart:added', function () { abrir(); });
    document.addEventListener('cart:refresh', function () { if (aberto) atualizar(); });
    window.addEventListener('pageshow', function () { ocupado = false; brindeOcupado = false; if (aberto) atualizar(); else api.carrinho().then(function (c) { atualizarContadores(c.item_count); }).catch(function () {}); });
    api.carrinho().then(function (c) { carrinho = c; atualizarContadores(c.item_count); brindeAutomatico(c); }).catch(function () {});
    window.EwcCart = { abrir: abrir, fechar: fechar, atualizar: atualizar, carrinho: function () { return carrinho; }, config: function () { return cfg; } };
  }
  try {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
  } catch (e) { /* falha aberto */ }
})();
